import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BookOpen } from 'lucide-react';
import { Dropdown } from './Dropdown';
import { PetsDropdown } from './PetsDropdown';
import { SupportDropdown } from './SupportDropdown';
import { AccessibilityDropdown } from './AccessibilityDropdown';
import { AdoptionDropdown } from './AdoptionDropdown.tsx';
import { AboutDropdown } from './AboutDropdown';

interface DesktopNavProps {
  adjustFontSize: (delta: number) => void;
  fontSize: number;
}

export function DesktopNav({ adjustFontSize, fontSize }: DesktopNavProps) {
  const location = useLocation();

  return (
    <div className="hidden md:flex items-center gap-1" role="navigation" aria-label="Menu główne">
      <AdoptionDropdown location={location} />
      <SupportDropdown location={location} />
      <AboutDropdown location={location} />
      <div className="flex items-center gap-1 ml-4 pl-4 border-l border-accessible-gray-200 dark:border-accessible-gray-700 high-contrast:border-white/20">
        <AccessibilityDropdown adjustFontSize={adjustFontSize} fontSize={fontSize} />
      </div>
    </div>
  );
}